import _taggedTemplateLiteral from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n          mutation ($phone: String!, $password: String!) {\n            signIn(phone: $phone, password: $password) {\n              createdAt\n              dealer {\n                id\n                ifStoreOpening\n                status\n              }\n              email\n              id\n              jwt\n              phone\n              role\n              updatedAt\n              username\n            }\n          }\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __decorate } from "tslib";
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import gql from 'graphql-tag';
import AppCheckbox from '@/components/AppCheckbox.vue';
import { SnackType } from '@/interfaces/snack';
import { dispatchSignIn } from '@/store/dispatches';
import { showErrors, showNotification } from '@/utils/snack';
import { State } from 'vuex-class';
import { AuditStatus } from '@/interfaces/status';

var SignIn = /*#__PURE__*/function (_Vue) {
  _inherits(SignIn, _Vue);

  var _super = _createSuper(SignIn);

  function SignIn() {
    var _this;

    _classCallCheck(this, SignIn);

    _this = _super.apply(this, arguments);
    _this.password = '';
    _this.username = '';
    _this.showPWD = false;
    _this.rememberMe = true;
    _this.rules = {
      required: function required(value, type) {
        return !!value || type + '不能为空';
      }
    };
    _this.valid = true;
    return _this;
  }

  _createClass(SignIn, [{
    key: "validate",
    value: function validate() {
      if (this.form.validate()) {
        this.signIn();
      }
    }
  }, {
    key: "signIn",
    value: function () {
      var _signIn = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var result, me, _me$dealer, typedError;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.$apollo.mutate({
                  mutation: gql(_templateObject()),
                  variables: {
                    phone: this.username,
                    password: this.password
                  }
                });

              case 3:
                result = _context.sent;
                me = result.data.signIn;

                if (!me) {
                  _context.next = 15;
                  break;
                }

                if (!(me.role === 'DEALER')) {
                  _context.next = 10;
                  break;
                }

                if (!(((_me$dealer = me.dealer) === null || _me$dealer === void 0 ? void 0 : _me$dealer.status) !== AuditStatus.APPROVED)) {
                  _context.next = 10;
                  break;
                }

                showNotification({
                  msg: '审核未通过',
                  type: SnackType.Error
                });
                return _context.abrupt("return", false);

              case 10:
                localStorage.setItem(process.env.VUE_APP_LOCAL_STORAGE_KEY, me.jwt + '');
                sessionStorage.setItem('role', me.role);
                dispatchSignIn(me);
                showNotification({
                  msg: '登录成功',
                  type: SnackType.Success
                });
                setTimeout(function () {
                  _this2.$router.push({
                    name: 'Home'
                  });
                }, 1000);

              case 15:
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](0);
                typedError = _context.t0;
                showErrors(typedError.graphQLErrors);

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 17]]);
      }));

      function signIn() {
        return _signIn.apply(this, arguments);
      }

      return signIn;
    }()
  }, {
    key: "form",
    get: function get() {
      return this.$refs.form;
    }
  }, {
    key: "version",
    get: function get() {
      return process.env.VUE_APP_VERSION || '';
    }
  }]);

  return SignIn;
}(Vue);

__decorate([State(function (state) {
  return state.user.me;
})], SignIn.prototype, "me", void 0);

SignIn = __decorate([Component({
  components: {
    AppCheckbox: AppCheckbox
  }
})], SignIn);
export default SignIn;